/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S11_Supabase_BodyInputs */

const tr_mesafeli_s11_supabase_body = /** @type {(inputs: Mesafeli_S11_Supabase_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postgres veritabanı, kimlik doğrulama, dosya depolama.`)
};

const en_mesafeli_s11_supabase_body = /** @type {(inputs: Mesafeli_S11_Supabase_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postgres database, authentication, file storage.`)
};

const de_mesafeli_s11_supabase_body = /** @type {(inputs: Mesafeli_S11_Supabase_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postgres-Datenbank, Authentifizierung, Dateispeicher.`)
};

const ru_mesafeli_s11_supabase_body = /** @type {(inputs: Mesafeli_S11_Supabase_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`База данных Postgres, аутентификация, хранение файлов.`)
};

/**
* | output |
* | --- |
* | "Postgres database, authentication, file storage." |
*
* @param {Mesafeli_S11_Supabase_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s11_supabase_body = /** @type {((inputs?: Mesafeli_S11_Supabase_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S11_Supabase_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s11_supabase_body(inputs)
	if (locale === "de") return de_mesafeli_s11_supabase_body(inputs)
	if (locale === "ru") return ru_mesafeli_s11_supabase_body(inputs)
	return tr_mesafeli_s11_supabase_body(inputs)
});